/* B2B_ACCOUNT_STATEMENTS */
export const GET_B2B_ACCOUNT_STATEMENTS = "GET_B2B_ACCOUNT_STATEMENTS";
export const GET_B2B_ACCOUNT_STATEMENTS_SUCCESS = "GET_B2B_ACCOUNT_STATEMENTS_SUCCESS";
export const GET_B2B_ACCOUNT_STATEMENTS_FAIL = "GET_B2B_ACCOUNT_STATEMENTS_FAIL";
export const GET_CLAB_ACCOUNT_STATEMENTS = "GET_CLAB_ACCOUNT_STATEMENTS";
export const GET_CLAB_ACCOUNT_STATEMENTS_SUCCESS = "GET_CLAB_ACCOUNT_STATEMENTS_SUCCESS";
export const GET_CLAB_ACCOUNT_STATEMENTS_FAIL = "GET_CLAB_ACCOUNT_STATEMENTS_FAIL";